import React, {
  useEffect,
  useState,
} from 'react';
import {
  Button, Col, Row, Card,
} from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import Table from 'components/Table';
import { getTiposDeVisita, getVisitaDomiciliaria } from 'api/tramite/VisitasDomiciliarias';
import FormSubmitControls from 'components/FormSubmitControls';
import TabsVisitas from '../components/Tramite/VisitasDomiciliarias/index';

const baseURI = '/tramites/plantillas-de-tramites/';

const VisitasDomiciliarias = () => {
  const [data, setData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [currentPage, setCurrentPage] = useState([]);
  const [visible, setVisible] = useState(true);

  const getVisitas = async () => {
    const request = await getTiposDeVisita();
    setData(request);
  };

  useEffect(() => {
    if (visible) {
      getVisitas();
    }
  }, [visible]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (_selectedRowKeys) => {
      setSelectedRowKeys(_selectedRowKeys);
    },
  };

  const handleOnRowClick = (record) => {
    console.log(record);
    setSelectedRowKeys([record]);
  };

  const onClickAdd = () => {
    console.log('Add');
  };

  const onClickEdit = async () => {
    // const request = await getVisitaDomiciliaria(selectedRowKeys[0]?.id);
    // if (request) {
    //   console.log(request);
    //   setData(request);
    // }
    setVisible(false);
  };

  const onFinish = () => {
    console.log('Finish');
  };

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(true);
    console.log('Cancel');
  };

  const onClickDelete = () => {
    setSelectedRowKeys([]);
    setVisible(true);
    console.log('Delete');
  };

  const callbackInformation = (_data) => {
    console.log(_data);
    console.log('Callback');
  };

  const columns = [
    {
      titleText: 'Nombres',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      titleText: 'Descripción',
      dataIndex: 'objetivo',
      key: 'objetivo',
    },
    {
      titleText: 'Estado de Ficha',
      dataIndex: 'costo_inspeccion',
      key: 'costo_inspeccion',
    },
    {
      titleText: 'Dependencia',
      dataIndex: 'dependencia',
      key: 'dependencia',
    },
  ];

  return (
    <Row>
      {
        visible ? (
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            mobileColIndex={0}
            rowKey="id"
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit,
              onClickDelete,
            }}
            allowImport
            baseURI={baseURI}
            pagination={false}
            // paginationCallback={fetchData}
            currentPage={currentPage}
          />
        ) : (
          <Card
            bordered={false}
            style={{ width: '100%' }}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                allowSaveAndContinue={!!selectedRowKeys.length}
              />
          )}
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar Tramite'}`}
          >
            <Row gutter={10} justify="end">
              <Col md={24}>
                <TabsVisitas
                  selectedRow={selectedRowKeys[0]}
                  callbackInformation={(_data) => callbackInformation(_data)}
                />
              </Col>
            </Row>
          </Card>
        )
      }
    </Row>
  );
};

export default VisitasDomiciliarias;
